const attachmentDescriptorSchema = {
  type: "object",
  additionalProperties: false,
  properties: {
    type: { type: "string", enum: ["eventTicket", "badge"] },
    badgeId: { type: "integer" },
  },
  required: ["type"],
  allOf: [
    {
      if: {
        properties: { type: { const: "badge" } },
        required: ["type"],
      },
      then: { required: ["badgeId"] },
      else: { properties: { badgeId: false } },
    },
  ],
};

const attachmentsSchema = {
  type: ["array", "null"],
  items: attachmentDescriptorSchema,
  maxItems: 1,
};

export const createEmailCampaignSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
    },
    required: ["eventId"],
  },
  body: {
    type: "object",
    additionalProperties: false,
    properties: {
      subject: { type: "string" },
      content: { type: ["object", "null"] },
      contentHtml: { type: ["string", "null"] },
      targetedTagIds: {
        type: ["array", "null"],
        items: { type: "string" },
      },
      attachments: attachmentsSchema,
    },
    required: ["subject"],
  },
};

export const web_createEmailCampaignSchema = {
  type: "object",
  additionalProperties: false,
  properties: {
    subject: { type: "string" },
    content: { type: ["object", "null"] },
    contentHtml: { type: ["string", "null"] },
    targetedTagIds: {
      type: ["array", "null"],
      items: { type: "string" },
    },
    attachments: attachmentsSchema,
  },
  required: ["subject"],
};

export const updateEmailCampaignSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
      id: { type: "string" },
    },
    required: ["eventId", "id"],
  },
  body: {
    type: "object",
    additionalProperties: false,
    properties: {
      subject: { type: "string" },
      content: { type: ["object", "null"] },
      contentHtml: { type: ["string", "null"] },
      scheduledAt: { type: ["string", "null"], format: "date-time" },
      targetedTagIds: {
        type: ["array", "null"],
        items: { type: "string" },
      },
      attachments: attachmentsSchema,
    },
  },
};

export const getEmailByIdCampaignSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "string" },
      eventId: { type: "string" },
    },
    required: ["id", "eventId"],
  },
};

export const listEmailCampaignsSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
    },
    required: ["eventId"],
  },
  query: {
    type: "object",
    properties: {
      status: {
        type: "string",
        pattern: "^(draft|scheduled|sent)(,(draft|scheduled|sent))*$",
      },
      page: { type: "integer", minimum: 1, default: 1 },
      limit: { type: "integer", minimum: 1, maximum: 100, default: 10 },
    },
  },
};

export const listCampaignLogsSchema = {
  ...getEmailByIdCampaignSchema,
  query: {
    type: "object",
    properties: {
      status: {
        type: "string",
        pattern:
          "^(sent|delivered|opened|failed|pending)(,(sent|delivered|opened|failed|pending))*$",
      },
      page: { type: "integer", minimum: 1, default: 1 },
      limit: { type: "integer", minimum: 1, maximum: 100, default: 10 },
    },
  },
};

export const deleteEmailCampaignSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
    },
    required: ["eventId"],
  },
  body: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: { type: "string" },
    },
    required: ["id"],
  },
};

export const sendEmailCampaignSchema = {
  ...deleteEmailCampaignSchema,
};

export const sendEmailCampaignToTicketSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
      id: { type: "string" },
      ticketId: { type: "string" },
    },
    required: ["eventId", "id", "ticketId"],
  },
};

export const scheduleEmailCampaignSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
    },
    required: ["eventId"],
  },
  body: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: { type: "string" },
      scheduledAt: { type: "string", format: "date-time" },
    },
    required: ["id", "scheduledAt"],
  },
};

export const cancelScheduleCampaignSchema = {
  ...deleteEmailCampaignSchema,
};

export const recipientCountSchema = {
  params: {
    type: "object",
    properties: {
      eventId: { type: "string" },
    },
    required: ["eventId"],
  },
  query: {
    type: "object",
    properties: {
      tagIds: { type: "string" },
    },
  },
};
